import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgEngagementOnImpressionConfig = {
    name: 'kpi.linkedin.avg_engagement_rate_on_impression',
    id: 'average_engagement_on_impressions',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: 'kpi.linkedin.tooltip_avg_engagement_rate_on_impression',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_33,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
